export default "__VITE_ASSET__DYkcdc9m__"